import React from "react";
import "./ErrorPage.css";
import gsap from "gsap";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearSeatType } from "../redux/SeatsTypeSlice";
import { clearActive } from "../redux/ActiveClientAcoount";
import { clearAssignAdminCompany } from "../redux/AddAssignAdminCompany";
import { clearCityEmployee } from "../redux/AddCityBranchEmployee";
import { clearCompanyEmpBranch } from "../redux/AddCompanyEmpBranch";
import { clearTripManulaState } from "../redux/tripsManulDoneSlice";
import { clearBus } from "../redux/busSlice";
import { clearSeateState } from "../redux/SeatsSlice";
import { clearCity } from "../redux/CitySlice";
import { clearCompany } from "../redux/companyTransportSlice";
import { clearCompanyData1 } from "../redux/companyTransportDataSlice";
import { clearComplaints } from "../redux/Complaints";
import { clearEmployeeState } from "../redux/employeeSlice";
import { clearNotifcations } from "../redux/notificationslice";
import { clearOffices } from "../redux/Office";
import { clearPassengers } from "../redux/PasssengersTrip";
import { clearPath } from "../redux/PathSlice";
import { clearTripState } from "../redux/tripsSlice";
import { clearSetsbus } from "../redux/SetsBus";
import { clearRoles } from "../redux/RolesSlice";
import { clearPriveePoliceCompany } from "../redux/prvicepoliceCompany";
import { clearPrivecPolice } from "../redux/prvicepolice";
import { clearProfits } from "../redux/profit";
import { clearauth } from "../redux/authSlice";
import { clearpassengerState } from "../redux/reservationPassanger";
import { clearreservationsState } from "../redux/reservation";
import { clearPermissionState } from "../redux/Permission";
import { clearTripTypeState } from "../redux/tripTypesSlice";
import { clearTicket } from "../redux/TickeType";
import { clearTripScheluerState } from "../redux/tripsSchedularSlice";

export const MaintenancePage = () => {
  const dispatch = useDispatch();
  function logout() {
    // axios
    // .post(`${BaseUrl}/logout`)
    // .then(() => {
    dispatch(clearSeatType());
    dispatch(clearActive());
    dispatch(clearAssignAdminCompany());
    dispatch(clearCityEmployee());
    dispatch(clearCompanyEmpBranch());
    dispatch(clearTripManulaState());
    dispatch(clearBus());
    dispatch(clearSeateState());
    dispatch(clearCity());
    dispatch(clearCompany());
    dispatch(clearCompanyData1());
    dispatch(clearComplaints());
    dispatch(clearEmployeeState());
    dispatch(clearNotifcations());
    dispatch(clearOffices());
    dispatch(clearPassengers());
    dispatch(clearPath());
    dispatch(clearTripState());
    dispatch(clearSetsbus());
    dispatch(clearRoles());
    dispatch(clearPriveePoliceCompany());
    dispatch(clearPrivecPolice());
    dispatch(clearProfits());
    dispatch(clearauth());
    dispatch(clearpassengerState());
    dispatch(clearreservationsState());
    dispatch(clearPermissionState());
    dispatch(clearTripTypeState());
    dispatch(clearTicket());
    dispatch(clearTripScheluerState());
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("activeTab");
    setTimeout(() => {
      window.location.reload();
    }, 500);
    // })

    // .catch((error) => {
    //   // Handle error if needed
    // });
  }
  useEffect(() => {
    const t1 = gsap.timeline({ repeat: -1 });
    const t2 = gsap.timeline({ repeat: -1 });
    const t3 = gsap.timeline({ repeat: -1 });

    t1.to(".cog1", {
      transformOrigin: "50% 50%",
      rotation: "+=360",
      ease: "linear.none",
      duration: 8,
    });

    t2.to(".cog2", {
      transformOrigin: "50% 50%",
      rotation: "-=360",
      ease: "linear.none",
      duration: 8,
    });

    t3.fromTo(
      ".wrong-para",
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 1,
        stagger: {
          repeat: -1,
          yoyo: true,
        },
      }
    );
  }, []);

  return (
  <>
  
    <p class="title">الموقع قيد الصيانة </p>
    <p class="title-secound">سيتم تفعيل الموقع في وقت قريب</p>
    <div class="containere-maintenance">
      <div class="cog-wheel1">
        <div class="cog1">
          <div class="top"></div>
          <div class="down"></div>
          <div class="left-top"></div>
          <div class="left-down"></div>
          <div class="right-top"></div>
          <div class="right-down"></div>
          <div class="left"></div>
          <div class="right"></div>
        </div>
      </div>

      <div class="cog-wheel2">
        <div class="cog2">
          <div class="top"></div>
          <div class="down"></div>
          <div class="left-top"></div>
          <div class="left-down"></div>
          <div class="right-top"></div>
          <div class="right-down"></div>
          <div class="left"></div>
          <div class="right"></div>
        </div>
      </div>

      
      </div>
      <div className="box-back-page-login">
      <button className="back-page-login"    onClick={() => logout()}>
      رجوع 
      </button>
      </div>
    </>
  );
};